<template>
  <v-card flat>
    <v-toolbar flat dense>
      <v-spacer></v-spacer>
      <v-btn fab small @click="isEditing = !isEditing">
        <v-icon v-if="isEditing" color="primary"> mdi-close </v-icon>
        <v-icon v-else color="primary"> mdi-pencil </v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-text-field
          outlined
          :disabled="!isEditing"
          label="Name"
          v-model="taskDetails.name"
          :rules="[(v) => !!v || 'Task name is required.']"
          required
        ></v-text-field>
        <v-row dense>
          <v-col>
            <v-text-field
              outlined
              :disabled="true"
              label="Date Created"
              :value="formatDate(taskDetails.created_at)"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              outlined
              :disabled="true"
              label="Last Updated"
              :value="formatDate(taskDetails.updated_at)"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-textarea
          outlined
          :disabled="!isEditing"
          label="Description"
          v-model="taskDetails.description"
          auto-grow
          :rules="[(v) => !!v || 'Task description is required.']"
          required
        ></v-textarea>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :disabled="!isEditing" color="secondary" @click="deleteTask">
            <v-icon>mdi-delete</v-icon> Delete
          </v-btn>
          <v-btn
            :disabled="!isEditing || !valid"
            color="primary"
            @click="saveTask"
            ><v-icon small>mdi-content-save</v-icon> Save</v-btn
          >
        </v-card-actions>
      </v-form>
    </v-card-text>
    <v-snackbar v-model="hasSaved" :timeout="2000" absolute bottom left>
      Your changes have been saved.
    </v-snackbar>
    <v-snackbar v-model="hasDeleted" :timeout="2000" absolute bottom left>
      The task has been deleted.
    </v-snackbar>
  </v-card>
</template>

<script>
import { Bus } from '@/bus'

export default {
  props: ['taskDetails'],
  data () {
    return {
      hasSaved: false,
      hasDeleted: false,
      isEditing: null,
      valid: true
    }
  },
  methods: {
    saveTask () {
      this.$refs.form.validate()
      if (this.$refs.form.validate()) {
        try {
          this.$store.dispatch('bcm/updateBlueprintTask', this.taskDetails)
        } catch (err) {
          Bus.$emit('alert', {
            color: 'error',
            message: `Failed to update Task in Blueprint Content Manager`
          })
        } finally {
          this.isEditing = !this.isEditing
          this.hasSaved = true
        }
      }
    },
    async deleteTask () {
      if (
        confirm(`Are you sure you want to delete ${this.taskDetails.name}?`)
      ) {
        try {
          await this.$store.dispatch('bcm/deleteTask', [this.taskDetails.id])
        } catch (err) {
          Bus.$emit('alert', {
            color: 'error',
            message: 'Failed to delete Task in Blueprint Content Manager'
          })
        } finally {
          this.hasDeleted = true
          this.isEditing = !this.isEditing
          this.$router.push('/bcm')
        }
      }
    },
    formatDate (dateString) {
      var options = { year: 'numeric', month: 'long', day: 'numeric' }
      const parsedDate = new Date(dateString)
      return parsedDate.toLocaleString('en-US', options)
    }
  }
}
</script>
